class ProductCombinedImages {
  constructor() {
    this.gallery = document.querySelector("media-gallery");
    if (!this.gallery) return;

    this.mediaItems = this.gallery.querySelectorAll(".media-viewer__item");
    this.init();
  }

  init() {
    // Obtener la variante activa inicial (primero de la URL, luego del enlace activo)
    const urlVariantId = this.getVariantIdFromUrl();
    const activeVariant = urlVariantId || this.getActiveVariantId();

    if (activeVariant) {
      this.variantId = activeVariant;
      this.filterImagesByVariant(this.variantId);

      // Si la variante viene de la URL, activar el enlace correspondiente
      if (urlVariantId) {
        this.activateVariantLink(urlVariantId);
      }
    }

    // Escuchar cambios en los selectores de variantes
    document.addEventListener("variant:changed", (event) => {
      if (event.detail && event.detail.variantId) {
        this.variantId = event.detail.variantId;
        this.filterImagesByVariant(this.variantId);
      }
    });

    // Observar cambios en los enlaces de variantes
    const variantLinks = document.querySelectorAll(
      ".product-sister .opt-label.product-label-swatches"
    );

    variantLinks.forEach((link) => {
      link.addEventListener("click", (event) => {
        const href = link.getAttribute("href");
        if (href) {
          // Permitir la navegación normal
          window.location.href = href;
        }
      });
    });
  }

  getVariantIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");
    return variantId;
  }

  activateVariantLink(variantId) {
    const variantLinks = document.querySelectorAll(
      ".product-sister .opt-label.product-label-swatches"
    );
    variantLinks.forEach((link) => {
      const href = link.getAttribute("href");
      if (href && href.includes(`variant=${variantId}`)) {
        // Remover la clase activa de todos los enlaces
        variantLinks.forEach((l) =>
          l.classList.remove("dids-product-related--active")
        );
        // Agregar la clase activa al enlace correspondiente
        link.classList.add("dids-product-related--active");
      }
    });
  }

  getActiveVariantId() {
    // Buscar el enlace activo por la clase dids-product-related--active
    const activeLink = document.querySelector(
      ".product-sister .opt-label.product-label-swatches.dids-product-related--active"
    );

    if (activeLink) {
      const href = activeLink.getAttribute("href");

      if (href) {
        // Extraer el ID de la variante del href
        const variantMatch = href.match(/variant=(\d+)/);
        if (variantMatch) {
          const variantId = variantMatch[1];
          return variantId;
        }
      }
    }

    return null;
  }

  filterImagesByVariant(variantId) {
    if (!variantId) {
      // Si no hay variante seleccionada, mostrar todas las imágenes
      this.mediaItems.forEach((item) => {
        item.classList.remove("hidden");
      });
      return;
    }

    this.mediaItems.forEach((item) => {
      const itemVariantId = item.getAttribute("data-variant-id");
      const isMainImage = item.classList.contains("is-main-image");

      if (isMainImage) {
        item.classList.remove("hidden");
      } else {
        item.classList.toggle("hidden", itemVariantId !== variantId);
      }
    });

    // Actualizar el contador de imágenes si existe
    const counter = this.gallery.querySelector(".media-ctrl__counter");
    if (counter) {
      const visibleItems = this.gallery.querySelectorAll(
        ".media-viewer__item:not(.hidden)"
      ).length;
      counter.querySelector(".media-ctrl__current-item").textContent = "1";
      counter.querySelector(".media-ctrl__total-items").textContent =
        visibleItems;
    }

    // Actualizar los botones de navegación
    this.updateNavigationButtons();
  }

  updateNavigationButtons() {
    const prevButton = this.gallery.querySelector('button[name="prev"]');
    const nextButton = this.gallery.querySelector('button[name="next"]');
    if (!prevButton || !nextButton) return;

    const visibleItems = Array.from(this.mediaItems).filter(
      (item) => !item.classList.contains("hidden")
    );
    const currentIndex = Array.from(visibleItems).findIndex((item) =>
      item.classList.contains("is-current-variant")
    );

    prevButton.disabled = currentIndex <= 0;
    nextButton.disabled = currentIndex >= visibleItems.length - 1;
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener("DOMContentLoaded", () => {
  new ProductCombinedImages();
});

// También inicializar cuando se cargue el tema
document.addEventListener("shopify:section:load", (event) => {
  if (event.target.querySelector("media-gallery")) {
    new ProductCombinedImages();
  }
});
